import { UserRole } from "./roles";
import { UserSource } from "./source";
import { IdType } from "./index";

export interface IProfile {
	id: IdType;
	source: UserSource;
	roles: UserRole[];

	addRole( role: UserRole ): void;

	hasRole( role: UserRole ): boolean;

	checkRole( roleMap: number ): boolean;

}

type IBaseProfile<X> = {
	[key in keyof X]: X[key];
};

export class BaseProfile implements IProfile {
	id: IdType;
	roles: UserRole[];
	source: UserSource;

	protected constructor( source: UserSource, id: IdType, roles?: UserRole[] ) {
		this.source = source;
		this.id = id;
		if ( roles ) this.roles = roles;
		else this.roles = [];
	}

	public addRole( role: UserRole ) {
		if ( this.hasRole( role ) ) return;
		this.roles = [ ...this.roles, role ];
	}

	public hasRole( role: UserRole ): boolean {
		return this.roles.find( x => x.id === role.id ) != undefined;
	}

	public refreshRoles() {

	}

	checkRole( roleMap: number ): boolean {
		// tslint:disable-next-line:no-bitwise
		const roles = this.roles.filter( x => ( x.id & roleMap ) > 0 );
		if ( roles && roles.length > 0 ) return true;
		return false;
	}
}

export function createProfile<T extends IProfile, X>( c: { new( data: X ): T; }, data: X ): T {
	return new c( data );
}
